export default "__VITE_ASSET__Cwl5izvF__"